import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../../Units/Avatar';
import ClubAvatar from '../../Units/ClubAvatar';

const totalStarsCount = 10;
const ClubRow = ({ club, avatar }) => {

    return (
        <Link to={`/club/${club.clubId}`} className={`internalContentOfContent`}>
            <div className={`clubTab`}>
                <ClubAvatar id={club.clubId} />
                <div className={"clubName"}>
                    <div className={`clubNameTitle`}>
                    <span className="name">
                        {club.clubName}
                    </span>
                    </div>
                    {/* <div className={'clubRate'}>
                        {
                            [...Array(totalStarsCount)].map((e, index) =>
                                <span key={index} className={index < club.level ? 'rateStar' : 'emptyStar'}></span>
                            )
                        }
                    </div> */}
                </div>
                { club.unionId && <span className={`unionLogo`} /> }
            </div>
        </Link>)
};

export default ClubRow;
